import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { useI18n } from '../../config/i18n';
export function TaskConditionsIntroScreen({
  onNext
}: ScreenProps) {
  const {
    t
  } = useI18n();
  return <div className="flex flex-col h-full" data-id="element-1564">
      <div className="flex-1 flex flex-col justify-center px-2" data-id="element-1565">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="space-y-6" data-id="element-1566">
          <div className="flex items-center gap-3 mb-2" data-id="element-1567">
            <div className="w-10 h-10 rounded-xl bg-yellow-100 flex items-center justify-center" data-id="element-1568">
              <ShieldAlertIcon className="w-5 h-5 text-yellow-500" data-id="element-1569" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-1570">
              {t('condIntro.title')}
            </h2>
          </div>

          <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1571">
            {t('condIntro.subtitle')}
          </p>

          <div className="space-y-3" data-id="element-1572">
            <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.15
          }} className="bg-white border border-emerald-200 rounded-lg p-3 flex items-start gap-3" data-id="element-1573">
              <span className="px-2 py-0.5 rounded bg-emerald-50 text-emerald-600 text-xs font-bold border border-emerald-200 flex-shrink-0 mt-0.5" data-id="element-1574">
                E
              </span>
              <div data-id="element-1575">
                <p className="text-gray-900 font-semibold text-sm" data-id="element-1576">
                  {t('condIntro.environment')}
                </p>
                <p className="text-gray-500 text-xs mt-0.5" data-id="element-1577">
                  {t('condIntro.environmentDesc')}
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.25
          }} className="bg-white border border-blue-200 rounded-lg p-3 flex items-start gap-3" data-id="element-1578">
              <span className="px-2 py-0.5 rounded bg-blue-50 text-blue-600 text-xs font-bold border border-blue-200 flex-shrink-0 mt-0.5" data-id="element-1579">
                C
              </span>
              <div data-id="element-1580">
                <p className="text-gray-900 font-semibold text-sm" data-id="element-1581">
                  {t('condIntro.capability')}
                </p>
                <p className="text-gray-500 text-xs mt-0.5" data-id="element-1582">
                  {t('condIntro.capabilityDesc')}
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.35
          }} className="bg-white border border-amber-200 rounded-lg p-3 flex items-start gap-3" data-id="element-1583">
              <span className="px-2 py-0.5 rounded bg-amber-50 text-amber-600 text-xs font-bold border border-amber-200 flex-shrink-0 mt-0.5" data-id="element-1584">
                M
              </span>
              <div data-id="element-1585">
                <p className="text-gray-900 font-semibold text-sm" data-id="element-1586">
                  {t('condIntro.motivation')}
                </p>
                <p className="text-gray-500 text-xs mt-0.5" data-id="element-1587">
                  {t('condIntro.motivationDesc')}
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>

      <div className="sticky bottom-0 z-10 pt-3 pb-2 bg-gray-50" data-id="element-1588">
        <PrimaryButton onClick={onNext} data-id="element-1589">
          {t('condIntro.continue')}
        </PrimaryButton>
      </div>
    </div>;
}